/* eslint-disable no-console */
/* eslint-disable no-use-before-define */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable import/no-extraneous-dependencies */
import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { Button } from '@mui/material';
import axios from 'axios';
import { useStateContext } from '../contexts/ContextProvider';
import { variables } from '../components/Variables';
import './FileViewPage.css'; // Importing the CSS file for custom styles

const FileViewPage = () => {
  const [show, setShow] = useState(false);
  const [files, setFiles] = useState([]);
  const [selectedFileUrl, setSelectedFileUrl] = useState('');
  const [fileContent, setFileContent] = useState('');
  const [allData, setAllData] = useState({});
  const { childData } = useStateContext();

  const fetchFiles = async () => {
    const requestData = {
      DirectorySerialNumber: childData.Serial,
    };

    try {
      const response = await axios.post(`${variables.BASE_URL}AccessTestLogFile`, requestData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const { data } = response;
      if (data.IsSuccess && data.IsAuthorize) {
        setFiles(data.AccessTestLogFile);
        setAllData(data);
        if (data.AccessTestLogFile.length > 0) {
          // Select the first file by default
          const firstFilePath = `${variables.FILE_URL}${data.SerialNumber}/${data.AccessTestLogFile[0].FilePath}`;
          setSelectedFileUrl(firstFilePath);
          loadFileContent(firstFilePath);
        }
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  const loadFileContent = async (filePath) => {
    try {
      const response = await axios.get(filePath, {
        headers: {
          'Content-Type': 'text/plain',
        },
      });
      setFileContent(response.data);
    } catch (error) {
      console.log('error', error);
    }
  };

  useEffect(() => {
    if (show) {
      fetchFiles();
    }
  }, [show]);

  const handleFileSelect = (filePath) => {
    setSelectedFileUrl(filePath);
    loadFileContent(filePath);
  };

  const handleDownload = () => {
    const element = document.createElement('a');
    const file = new Blob([fileContent], { type: 'text/plain' });
    element.href = URL.createObjectURL(file);
    element.download = selectedFileUrl.split('/').pop(); // Use the filename from the URL
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  };

  return (
    <div>
      <Button
        sx={{ display: 'none' }}
        variant="primary"
        onClick={() => setShow(true)}
        id="Serial_Popup"
      >
        Modal
      </Button>

      <Modal
        show={show}
        backdrop="static"
        onHide={() => setShow(false)}
        dialogClassName="modal-70w" // Custom class for 70% width modal
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            {allData.SerialNumber}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="file-view-container">
            <div className="file-list">
              <ul>
                {files.map((file, index) => (
                  <li key={index}>
                    <Button
                      onClick={() => handleFileSelect(`${variables.FILE_URL}${allData.SerialNumber}/${file.FilePath}`)}
                      className="file-button" // Custom class for file buttons
                    >
                      {/* <Button
                      onClick={() => handleFileSelect(`${variables.FILE_URL}${allData.SerialNumber}/${encodeURIComponent(file.FilePath).replace(/%2F/g, '/').replace(/%3A/g, ':')}`)}
                      className="file-button"
                    >       THIS IS CODE FOR FILE NAME CHANGE WHILE FETCHING FILE(REPLACE THE SPECIAL CHARACTERS) */}
                      {file.FileDiplayName}
                    </Button>
                  </li>
                ))}
              </ul>
            </div>
            <div className="file-content">
              {selectedFileUrl && (
                <div>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleDownload}
                    style={{ marginBottom: '1rem' }}
                  >
                    Download
                  </Button>
                  <iframe
                    src={selectedFileUrl}
                    width="100%"
                    height="600px"
                    title="Text File Viewer"
                    style={{ border: 'none' }}
                  />
                </div>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default FileViewPage;
